// TasksList.jsx
import React from "react";
import TasksView from "./TasksView";
import { useNavigate } from "react-router-dom";

const TasksList = () => {
  const navigate = useNavigate();

  const handleEdit = (task) => {
    navigate(`/tasks/edit/${task.story_id}`);
  };

  return <TasksView onEditTask={handleEdit} />;
};

export default TasksList;